<div class="app-page-control">
  <div class="top-control">
    <div
      class="top-contorl-left-wrapper"
      *ngIf="view === ZONE_VIEWER.TREE_VIEW"
    >
      <div class="back-icon-container" *ngIf="!_service.rbacManagement('tracker_MapView')">
        <div
          class="icon"
          (click)="onBackButtonClick('ALL_SITES')"
          [matTooltip]="'Back To ' + ('plants' | translate) + ' Tree Listing'"
        ></div>
      </div>
      <div class="breadcrumb-labels">
        <ul>
          <li
            *ngFor="
              let label of treeViewFilteredList;
              let last = last;
              let i = index;
              trackBy: trackByCrumbs
            "
            [ngClass]="{ 'last-label': last }"
          >
            {{ label }}
          </li>
        </ul>
        <span *ngIf="!treeViewFilteredList?.length" class="last-label"
          >All {{ "zone" | translate }}</span
        >
      </div>
    </div>
    <div
      class="top-contorl-left-wrapper"
      *ngIf="
        view === ZONE_VIEWER.PLAN_VIEW || view === ZONE_VIEWER.PLANOGRAM_VIEW
      "
    >
      <div class="back-icon-container">
        <div
          class="icon"
          (click)="onBackButtonClick('TREE_VIEW')"
          [matTooltip]="'Back To Tree View'"
        ></div>
      </div>
      <div class="breadcrumb-labels">
        <ul>
          <li
            *ngFor="
              let label of zone?.zoneBreadCrumb;
              let last = last;
              let i = index;
              trackBy: trackByCrumbs
            "
            [ngClass]="{ 'last-label': last }"
          >
            {{ label }}
          </li>
        </ul>
      </div>
      <div class="header-count-container">
        <ul class="count-list">
          <li
            *ngFor="let item of headerCount; trackBy: trackByCount"
            class="count-item"
          >
            <div class="count-box" [matTooltip]="item?.name">
              <img
                *ngIf="item.imgUrl"
                [src]="item?.imgUrl"
                alt="Icon"
                class="count-icon"
              />
              <span class="count-value">{{ item?.count }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="top-contorl-right-wrapper">
      <!-- swtich toggle -->
      <div
        filter
        class="view-toggle-container"
        *ngIf="
          (view === ZONE_VIEWER.PLAN_VIEW ||
            view === ZONE_VIEWER.PLANOGRAM_VIEW) &&
          _service.rbacManagement('tracker_FloorPlan_FloorPlan_FloorPlanToggle')
        "
      >
        <ng-container>
          <span class="toggle-label">Floor Plan</span>
          <label class="toggle-switch">
            <input
              type="checkbox"
              [checked]="view === ZONE_VIEWER.PLANOGRAM_VIEW"
              (change)="toggleView()"
            />
            <span class="toggle-slider"></span>
          </label>
          <span class="toggle-label">Planogram</span>
        </ng-container>
      </div>
      <div *ngIf="view !== ZONE_VIEWER.TREE_VIEW">
        <form [formGroup]="datepickerForm">
        <app-datetime-range
          class=""
          formControlName="thisdate"
          [isDisabled]="false"
          [label]="'Date Range'"
          [autoApply]="false"
          [showCancel]="true"
          [timePicker]="true"
          [timePicker24Hour]="true"
          [timePickerSeconds]="true"
          [iconOnly]="true"
          [showCustomRangeLabel]="false"
          [alwaysShowCalendars]="true"
          [keepCalendarOpeningWithRange]="true"
          [opens]="'left'"
          (datePassed)="saveTime($event)"
        >
        </app-datetime-range>
      </form>
      </div>
      <div
        *ngIf="filterVisible"
        class="text-right pf-wrapper"
        [class.active-filter]="filterCount || treeViewFilteredList?.length"
        (click)="handleFilter()"
      >
        <div
          class="planogram-filter-icon"
          [class.active-filter]="filterCount || treeViewFilteredList?.length"
          [matTooltip]="'Filter'"
        ></div>
        <ng-container *ngIf="filterCount">
          <span class="filter-counter">Filter ({{ filterCount }})</span>
        </ng-container>
        <ng-container *ngIf="treeViewFilteredList?.length">
          <span class="filter-counter"
            >Filter ({{ treeViewFilteredList?.length }})</span
          >
        </ng-container>
      </div>
      <div
        class="icon-container"
        *ngIf="
          (_service.rbacManagement('tracker_FloorPlan_TableView') &&
            view === ZONE_VIEWER.TREE_VIEW) ||
          (_service.rbacManagement('tracker_FloorPlan_FloorPlan_TableView') &&
            view === ZONE_VIEWER.PLAN_VIEW) ||
          (_service.rbacManagement('tracker_FloorPlan_Planogram_TableView') &&
            view === ZONE_VIEWER.PLANOGRAM_VIEW)
        "
      >
        <div
          class="icon"
          [matTooltip]="'Table View'"
          (click)="handleTableView()"
        ></div>
      </div>
    </div>
  </div>
  <div
    class="bottum-control"
    *ngIf="
      view === ZONE_VIEWER.PLAN_VIEW || view === ZONE_VIEWER.PLANOGRAM_VIEW
    "
  >
    <div *ngFor="let item of statusDetails; trackBy: trackByTrackedState">
      <div
        class="oval-tile"
        [ngClass]="'tracked-state-' + (item?.trackedState ?? 'null')"
        [ngStyle]="{
              'color': statusColorMapping[item?.trackedState ?? 'null'],
            }"
      >
        <span class="indicator-wrapper">
          <span
            class="planogram-status-indicator"
            [ngStyle]="{
              'background-color':
                statusColorMapping[item?.trackedState ?? 'null']
            }"
          ></span>
          <span>{{ item?.name ?? "NA" }}</span>
        </span>
        <span class="o-t-num">{{ item?.count ?? "NA" }}</span>
      </div>
    </div>
  </div>
  <div class="date-display" *ngIf="view === ZONE_VIEWER.PLAN_VIEW || view === ZONE_VIEWER.PLANOGRAM_VIEW">
    <span>Date Range -&nbsp;</span>
    <ng-container *ngIf="selectedDateRangeLabel !== 'Custom'; else customDateRange">
      <span>{{ selectedDateRangeLabel ?? 'NA' }}</span>
    </ng-container>
    <ng-template #customDateRange>
      <span class="z-p-custom-date">
      {{displayDate}}
      </span>
    </ng-template>
  </div>
</div>
